// @flow
import React, { useState } from 'react'

import Button from '../Button'
import Row from '../Row'

const styles = {
  button: {
    borderWidth: 1,
    width: 80,
    marginLeft: -1,
  },
  firstButton: {
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    marginLeft: 0,
  },
  lastButton: {
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
  },
  selected: {
    backgroundColor: '#fabc09',
  },
  selectedLabel: {
    color: 'white',
    fontWeight: '600',
  },
}

type Props = {
  options: Object,
  onChange: Function,
  theme: Object,
  buttonStyle?: Object,
  buttonLabelStyle?: Object,
  value?: any,
}
const RadioButton = ({
  options,
  onChange,
  theme,
  buttonStyle,
  buttonLabelStyle,
  value,
}: Props) => {
  const { palette } = theme
  const [selected, setSelected] = useState(value || 0)

  return (
    <Row width="auto">
      {options.map((opt, idx) => {
        let style = styles.button, labelStyle
        if (idx === 0) {
          style = {
            ...style,
            ...styles.firstButton,
          }
        } else if (idx === options.length - 1) {
          style = {
            ...style,
            ...styles.lastButton,
          }
        }
        if (selected === opt.value) {
          style = {
            ...style,
            ...styles.selected,
          }
          labelStyle = styles.selectedLabel
          if (opt.activeColor) {
            style = {
              ...style,
              backgroundColor: opt.activeColor,
            }
          }
        }
        return (
          <Button
            key={'opt-' + opt.label}
            theme={theme}
            label={opt.label}
            labelStyle={labelStyle}
            onPress={() => {
              setSelected(opt.value)
              onChange && onChange(opt.value)
            }}
            width={100}
            borderRadius={0}
            borderColor={palette.border}
            style={style}
          />
        )
      })}
    </Row>
  )
}
export default RadioButton
